export const READ_EXHORTATION_NOTE = "READ_EXHORTATION_NOTE";
export const READ_EXHORTATION_NOTE_SUCCESS = "READ_EXHORTATION_NOTE_SUCCESS";
export const ON_CLOSE_MODAL = "ON_CLOSE_MODAL";